module.exports = __webpack_public_path__ + "img/byStatus.cec7aa87.png";